import _ from 'lodash'
// DON'T use ARROW function, these are bound to App instance

export function getServices (mid) {
  return this.api._minions.getServices(mid)
}

function _getArgSpecOrDoc (ftype, fname, what) {
  let propName = `${ftype}_${what}`
  if (_.isFunction(this.api._docs[propName]))
    return this.api._docs[propName](fname)
  propName = `function_${what}`
  if (_.isFunction(this.api._docs[propName]))
    return this.api._docs[propName](fname)
  throw new Error('Invalid params for docs request')
}

export function getArgSpec (ftype, fname) {
  return _getArgSpecOrDoc.bind(this)(ftype, fname, 'argspec')
}

export function getDoc (ftype, fname) {
  return _getArgSpecOrDoc.bind(this)(ftype, fname, 'doc')
}

export function doRunJob (data) {
  console.log('doRunJob from context', data)
  let {
    tgt, fun, arg, kwarg,
    expr_form = 'glob', client = 'local'
  } = data
  if(_.isArray(tgt)) {
    tgt = tgt.join(',')
    expr_form = tgt === '*' ? 'glob' : 'list'
  }
  console.log(
    'run job for: ',
    data, tgt, fun, arg, kwarg, expr_form, client)
  return this.api._run(tgt, fun, arg, kwarg, expr_form, client)
}

function _doServiceOnMinion (
  mid, service, action, expr_form = 'glob', client = 'local')
{
  return this.api._run(
    mid, `service.${action}`, service, undefined, expr_form, client)
}

export function serviceStart (mid, service, expr_form, client) {
  return _doServiceOnMinion.bind(this)(
    mid, service, 'start', expr_form, client)
}
export function serviceStop (mid, service, expr_form, client) {
  return _doServiceOnMinion.bind(this)(
    mid, service, 'stop', expr_form, client)
}
export function serviceRestart (mid, service, expr_form, client) {
  return _doServiceOnMinion.bind(this)(
    mid, service, 'restart', expr_form, client)
}
export function serviceEnable (mid, service, expr_form, client) {
  return _doServiceOnMinion.bind(this)(
    mid, service, 'enable', expr_form, client)
}
export function serviceDisable (mid, service, expr_form, client) {
  return _doServiceOnMinion.bind(this)(
    mid, service, 'disable', expr_form, client)
}



// WEBPACK FOOTER //
// ./src/App.actions.js